import { Button, Form, Input, Select, Space, message } from 'antd'
import { useState, useRef, Fragment, useImperativeHandle } from 'react'
import { Modal } from 'antd'
import User from '@/modules/user'
import CountDownBtn from '@/components/countDownBtn'
import styles from './index.scss'
import { SYSCON } from '@/const/const'
import ProvinceCityDropdown from '@/components/City/index'

const RegisterForm = (props) => {
  // 属性
  const formRef = useRef()
  const [appointmentVisible, handleModalVisible] = useState(false)
  const [formDisable, handleFormDisable] = useState(false)
  const [prods, handleProds] = useState([])
  const [showCityFlag, handleShowCityFlag] = useState(false)
  const [showProvinceNmFlag, handleProvinceNmFlag] = useState(false)
  const [provinceNm, setProvinceNm] = useState('') // 省份名称
  const [cityNm, setCityNm] = useState('') // 市名称
  // 用户初始化
  const user = new User()

  const [form] = Form.useForm()

  // 用useImperativeHandle暴露一些外部ref能访问的属性
  useImperativeHandle(props.onRef, () => {
    return {
      open
    }
  })
  const open = (title, appCatCd) => {
    handleModalVisible(true)
    console.log('user', user)

    const prodlist = (appCatCd === SYSCON.PlatAppExpense) ? user.getExpenseProds() : user.getProds()
    const prod = prodlist.find(p => p.nm === title)
    handleProds(prodlist)
    const userInfo = user.getUserInfo()
    if (userInfo) {
      console.log('userInfo', userInfo)
      handleFormDisable(true)
      form.setFieldsValue({
        applicantNm: userInfo.userNm || userInfo.nm || '',
        applicantPhone: userInfo.phone || userInfo.userInfo || ''
      })
    } else {
      handleFormDisable(false)
    }
    form.setFieldsValue({
      prodLvlId: (prod && prod.id) || ''
    })
    console.log('prodsprodsprods', prods)
  }
  // 预约请求
  const handleAppointment = (fields) => {
    // 加载信息
    const hide = message.loading('请稍等')
    user.onAppointment(fields)
      .then((data) => {
        hide()
        if (data.status === 210) {
          message.error(data.msg)
          return
        }
        if (data) {
          message.success('提交成功，我们将尽快联系您！')
          handleModalVisible(false)
        }
        setTimeout(()=>{
          form.resetFields()
        }, 300)
      })
      .catch(err => {
        hide()
        console.log('err', err)
      })
  }
  // 处理预约
  const onFinish = async(values) => {
    if (!provinceNm || !cityNm) return
    const prod = prods.find((f) => f.id === values.prodLvlId)
    const reqData = { ...values, prodLvlId: (prod && prod.id) || '', prodLvlNm: (prod && prod.nm) || '', prodNm: (prod ? prod.prodNm : prods[0].prodNm), prodId: (prod ? prod.prodId : prods[0].prodId), srcCd: SYSCON.ProdTrialSrcWorkbench, provinceNm, cityNm }
    console.log('reqData', reqData)
    const result = await handleAppointment({ ...reqData })
    if (result) {
      handleModalVisible(false)
    }
  }

  const handleSend = () => {
    const { applicantPhone } = form.getFieldsValue()
    console.log('applicantPhone', applicantPhone)

    return checkPhoneValue(applicantPhone).then(()=>{
      user.sendCode({ phone: applicantPhone })
      return Promise.resolve()
    }).catch((err)=>{
      return Promise.reject(err)
    })
  }

  const phoneValid = () => ({
    validator(_, value) {
      return checkPhoneValue(value)
    }
  })
  const handleClose = () => {
    handleModalVisible(false)
    setProvinceNm('')
    setCityNm('')
    handleShowCityFlag(false)
    handleProvinceNmFlag(false)
    setTimeout(()=>{
      form.resetFields()
    }, 300)
  }

  const validateVcode = () => ({
    validator(_, value) {
      console.log('valuevaluevaluevaluevalue', value)
      if (value) {
        const cnReg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
        if ((cnReg.test(value))) {
          return Promise.reject(new Error('验证码不能为中文'))
        } else {
          return Promise.resolve()
        }
      } else {
        return Promise.reject('验证码不能为空')
      }
    }
  })

  const checkPhoneValue = async(value)=>{
    console.log('value', value)

    if (value && value.length !== 11) {
      return Promise.reject(new Error('请输入11位的手机号!'))
    }
    console.log('value - 0', value - 0)

    if (!Number.isInteger(value - 0)) {
      return Promise.reject(new Error('请输入正确格式的手机号!'))
    }

    return Promise.resolve()
  }

  const cnInputCheck = (event) => {
    return event.target.value.replace(/[\u4E00-\u9FA5]/g, '').replace(/\s/g, '')
  }

  const handleCityData = (cityObj) => {
    setProvinceNm(cityObj.province)
    setCityNm(cityObj.city)
  }
  const validateCity = () => ({
    validator(_, value) {
      if (!provinceNm) {
        handleProvinceNmFlag(true)
      } else {
        handleProvinceNmFlag(false)
      }
      if (!cityNm) {
        handleShowCityFlag(true)
        return Promise.reject('')
      } else {
        handleShowCityFlag(false)
        return Promise.resolve()
      }
    }
  })
  return (
    <Fragment>
      <Modal
        destroyOnClose
        centered
        title='预约试用'
        visible={appointmentVisible}
        maskClosable={false}
        onCancel={() => handleClose()}
        footer={null}
        width={428}
      >
        <p className={styles['tip']}>我们将在预约提交后尽快联系您，并对您的信息严格保密</p>
        <Form
          labelCol={{ span: 5 }}
          form={form}
          ref={formRef}
          onFinish={onFinish}
          name='appointment'
        >
          <Form.Item
            name='applicantNm'
            label='姓名'

            rules={[
              { required: true, message: '姓名不能为空' },
              { max: 100, message: '不能超过100位' }
            ]}
          >
            <Input placeholder='请输入姓名' disabled={formDisable} autoComplete='off'/>
          </Form.Item>
          <Form.Item
            name='applicantPhone'
            label='手机号'

            rules={[
              { required: true, message: '手机号不能为空' },
              phoneValid
            ]}
          >
            <Input placeholder='请输入手机号' disabled={formDisable} autoComplete='off'/>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }} label='验证码'>
            <Form.Item
              name='code'
              rules={[validateVcode]}
              style={{ display: 'inline-block', width: 'calc(74% - 8px)' }}
              getValueFromEvent = {cnInputCheck}
            >
              <Input placeholder='请输入验证码' autoComplete='off'/>
            </Form.Item>
            <Form.Item
              style={{ display: 'inline-block', width: 'calc(26% - 8px)', margin: '0 8px' }}
            >
              <CountDownBtn handleSend={handleSend}/>
            </Form.Item>
          </Form.Item>
          <Form.Item
            name='rootOrgNm'
            label='企业名称'
            rules={[
              { required: true, message: '企业名称不能为空' },
              { max: 100, message: '不能超过100位' }
            ]}
          >
            <Input placeholder='请输入企业名称' autoComplete='off'/>
          </Form.Item>
          <Form.Item
            name='provinceNm'
            label='所属地区'
            rules={[validateCity]}
            required
          >
            <ProvinceCityDropdown styleSmallFlag={true} showProvinceNmFlag={showProvinceNmFlag} showCityFlag={showCityFlag} onChildClick={handleCityData} />
            { showCityFlag || showProvinceNmFlag ? <span style={{ color: '#ff4d4f', marginBottom: '-19px', display: 'block' }}>所属地区不能为空</span> : '' }
          </Form.Item>
          <Form.Item
            name='prodLvlId'
            label='试用版本'
          >
            <Select
              placeholder='请选择'
              allowClear
            >
              {
                prods && Array.isArray(prods) && prods.map((p) => {
                  return (<Select.Option value={p.id}>{p.nm}</Select.Option>)
                })
              }
              <Select.Option value=''>不太清楚</Select.Option>

            </Select>
          </Form.Item>
          <Form.Item
            name='notes'
            label='备注说明'
            rules={[
              { max: 100, message: '不能超过100位' }
            ]}
          >
            <Input placeholder='请填写备注' autoComplete='off' />
          </Form.Item>
          <Form.Item>
            <div className={styles['btns']}>
              <Space>
                <Button type='primary' htmlType='submit' >
             提交
                </Button>
              </Space>
            </div>

          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  )
}

export default RegisterForm
